// extracted by mini-css-extract-plugin
export default {"img":"Card_img__lKev+"};